var map = {
	"./apng/转盘能量汇聚.png": 72621,
	"./apng/金币.png": 19308,
	"./apng/闪电.png": 72517,
	"./figner.png": 857306,
	"./go.png": 923737,
	"./goal.png": 352962,
	"./guidebtn.png": 323315,
	"./itemgrey.png": 760355,
	"./itemlight.png": 371648,
	"./jackmodal/light1.png": 693529,
	"./jackmodal/light2.png": 145346,
	"./jackmodal/light3.png": 366475,
	"./jackmodal/major-jackpot.png": 572256,
	"./jackmodal/major.png": 64737,
	"./jackmodal/mini-jackpot.png": 594696,
	"./jackmodal/mini.png": 987081,
	"./jackmodal/minor-jackpot.png": 286820,
	"./jackmodal/minor.png": 12893,
	"./jackmodal/modalbg.png": 786396,
	"./jackmodal/sdicon.png": 758634,
	"./jackmodal/total.png": 497216,
	"./jackmodal/奖池-2.png": 153207,
	"./jackmodal/奖池-3.png": 679566,
	"./jackmodal/奖池.png": 635590,
	"./logo.png": 56782,
	"./main/advanced-obj1.png": 890634,
	"./main/advanced-obj2.png": 921217,
	"./main/advanced-obj3.png": 700088,
	"./main/advanced-obj4.png": 432727,
	"./main/advanced-obj5.png": 3502,
	"./main/advanced-obj6.png": 257509,
	"./main/advanced-obj7.png": 690972,
	"./main/advanced-obj8.png": 700459,
	"./main/master-obj1.png": 412258,
	"./main/master-obj2.png": 395193,
	"./main/master-obj3.png": 388944,
	"./main/master-obj4.png": 374319,
	"./main/master-obj5.png": 792774,
	"./main/master-obj6.png": 573981,
	"./main/master-obj7.png": 352852,
	"./main/master-obj8.png": 495123,
	"./main/normal-obj1.png": 860751,
	"./main/normal-obj2.png": 938292,
	"./main/normal-obj3.png": 159421,
	"./main/normal-obj4.png": 466626,
	"./main/normal-obj5.png": 230283,
	"./main/normal-obj6.png": 264880,
	"./main/normal-obj7.png": 980633,
	"./main/normal-obj8.png": 165070,
	"./minifire.png": 396674,
	"./miniother.png": 494770,
	"./miniself.png": 365464,
	"./modal/award1.png": 126757,
	"./modal/btn.png": 278081,
	"./modal/close.png": 47009,
	"./modal/foot.png": 927973,
	"./modal/rank1.png": 585870,
	"./modal/rank2.png": 457669,
	"./modal/rank3.png": 444604,
	"./modal/tipbg.png": 912271,
	"./modal/titleicon.png": 524900,
	"./modal/win.png": 776919,
	"./modal/三段式/bottom.png": 310952,
	"./modal/三段式/center.png": 788382,
	"./modal/三段式/top.png": 71948,
	"./modal/任务.png": 362353,
	"./modal/光.png": 262464,
	"./new.png": 866617,
	"./num/0.png": 975142,
	"./num/1.png": 260239,
	"./num/2.png": 337780,
	"./num/3.png": 558909,
	"./num/4.png": 866114,
	"./num/5.png": 629771,
	"./num/6.png": 148016,
	"./num/7.png": 380121,
	"./num/8.png": 48206,
	"./num/9.png": 38199,
	"./num/x.png": 351758,
	"./other.png": 78349,
	"./repeat-ok.png": 92083,
	"./repeat-select.png": 15681,
	"./repeat.png": 482510,
	"./resultgo.png": 25910,
	"./select.png": 962731,
	"./self.png": 539197,
	"./silvers/figner.png": 714411,
	"./silvers/ic_规则.png": 254686,
	"./silvers/ic_银币.png": 167392,
	"./silvers/背光.png": 60271,
	"./silvers/规则-金币.png": 971996,
	"./silvers/规则-银币.png": 126949,
	"./silvers/规则页三段式/bottom.png": 203859,
	"./silvers/规则页三段式/center.png": 83589,
	"./silvers/规则页三段式/top.png": 621801,
	"./silvers/金币彩带更新/金币彩带_atlas.png": 714105,
	"./silvers/金币彩带更新/金币彩带_atlas_1.png": 869145,
	"./silvers/金币彩带更新/金币彩带_atlas_1_phaser.json": 826164,
	"./silvers/金币彩带更新/金币彩带_atlas_2.png": 804610,
	"./silvers/金币彩带更新/金币彩带_atlas_2_phaser.json": 422619,
	"./silvers/金币彩带更新/金币彩带_atlas_phaser.json": 9924,
	"./subPage/avatar-border1.png": 821594,
	"./subPage/avatar-border2.png": 242705,
	"./subPage/avatar-border3.png": 732488,
	"./subPage/back.png": 21072,
	"./subPage/ball.png": 432410,
	"./subPage/rank1.png": 377894,
	"./subPage/rank2.png": 902781,
	"./subPage/rank3.png": 681652,
	"./subPage/tab-active.png": 791161,
	"./subPage/规则.png": 82360,
	"./ting/1/betbg.png": 398158,
	"./ting/1/betselectbg.png": 375638,
	"./ting/1/bg.png": 206921,
	"./ting/1/itembg.png": 188304,
	"./ting/1/num/0.png": 381239,
	"./ting/1/num/1.png": 238222,
	"./ting/1/num/2.png": 110021,
	"./ting/1/num/3.png": 96956,
	"./ting/1/num/4.png": 280563,
	"./ting/1/num/5.png": 125354,
	"./ting/1/num/6.png": 74337,
	"./ting/1/num/7.png": 106072,
	"./ting/1/num/8.png": 873551,
	"./ting/1/num/9.png": 834534,
	"./ting/1/num/x.png": 146703,
	"./ting/1/tab.png": 76191,
	"./ting/2/betbg.png": 531997,
	"./ting/2/betselectbg.png": 367765,
	"./ting/2/bg.png": 284916,
	"./ting/2/itembg.png": 184085,
	"./ting/2/num/0.png": 408652,
	"./ting/2/num/1.png": 320277,
	"./ting/2/num/2.png": 483550,
	"./ting/2/num/3.png": 175687,
	"./ting/2/num/4.png": 596072,
	"./ting/2/num/5.png": 528113,
	"./ting/2/num/6.png": 868218,
	"./ting/2/num/7.png": 458051,
	"./ting/2/num/8.png": 457860,
	"./ting/2/num/9.png": 121101,
	"./ting/2/num/x.png": 184708,
	"./ting/2/tab.png": 172872,
	"./ting/3/betbg.png": 623172,
	"./ting/3/betselectbg.png": 989724,
	"./ting/3/bg.png": 818647,
	"./ting/3/itembg.png": 847062,
	"./ting/3/num/0.png": 33729,
	"./ting/3/num/1.png": 812600,
	"./ting/3/num/2.png": 608211,
	"./ting/3/num/3.png": 876298,
	"./ting/3/num/4.png": 946725,
	"./ting/3/num/5.png": 710812,
	"./ting/3/num/6.png": 418391,
	"./ting/3/num/7.png": 235246,
	"./ting/3/num/8.png": 508281,
	"./ting/3/num/9.png": 502032,
	"./ting/3/num/x.png": 77881,
	"./ting/3/tab.png": 858149,
	"./whele/MAJOR.png": 501958,
	"./whele/MINI.png": 808460,
	"./whele/MINOR.png": 77234,
	"./whele/bagbg.png": 986742,
	"./whele/bigselect.png": 362831,
	"./whele/blutte.png": 323493,
	"./whele/bubble.png": 255839,
	"./whele/card.png": 737475,
	"./whele/count/,.png": 889373,
	"./whele/count/0.png": 580625,
	"./whele/count/1.png": 340680,
	"./whele/count/2.png": 677539,
	"./whele/count/3.png": 455962,
	"./whele/count/4.png": 830261,
	"./whele/count/5.png": 747372,
	"./whele/count/6.png": 615847,
	"./whele/count/7.png": 228158,
	"./whele/count/8.png": 443401,
	"./whele/count/9.png": 472224,
	"./whele/hightlight.png": 957505,
	"./whele/hightright.png": 140747,
	"./whele/jackpot.png": 830579,
	"./whele/l.png": 926277,
	"./whele/lock.png": 224252,
	"./whele/lowlef.png": 944974,
	"./whele/lowlight.png": 396623,
	"./whele/major-bg.png": 586264,
	"./whele/mini-bg.png": 614706,
	"./whele/minor-bg.png": 718716,
	"./whele/r.png": 544155,
	"./whele/smallselecr.png": 685950,
	"./whele/spin.png": 390237,
	"./whele/spinbtn.png": 833785,
	"./whele/top1Icon.png": 965388,
	"./whele/topBg.png": 548001,
	"./whele/unlock.png": 871177,
	"./whele/wheel1selected.png": 44400,
	"./whele/wheel2selected.png.png": 564396,
	"./whele/减-1.png": 732756,
	"./whele/减.png": 698030,
	"./whele/加-1.png": 958883,
	"./whele/加.png": 766361,
	"./whele/抽奖.png": 246208,
	"./whele/标题  jackpot.png": 384860,
	"./whele/标题 wheel.png": 546729,
	"./whele/框.png": 433327,
	"./whele/滑块.png": 744381,
	"./whele/背景框.png": 668514,
	"./whele/记录.png": 336800,
	"./whele/转盘 jackpot.png": 533507,
	"./whele/转盘 wheel.png": 310224,
	"./whele/转盘暴击.png": 381294,
	"./whele/返回.png": 310167,
	"./whele/钱袋.png": 660945,
	"./开奖记录.png": 292520,
	"./排行榜.png": 731641,
	"./火.png": 512040,
	"./规则.png": 804302,
	"./音效.png": 37738,
	"./音效关闭.png": 145734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 475275;